<template>
  <section id="main" class="main-viewport">
    <div class="subpage-banner py-4 img-only" style="background-image:url('images/banners/subpage-banner.jpg');">
      &nbsp;
    </div>
    <div class="subpage-content content-wrap mh-auto">
      <div class="container py-4 text-container">
        <div class="row no-gutters">
          <div class="col-12 col-lg-10 offset-lg-1 pt-3">
            <h1>About Viberary</h1>
            <p>
              Viberary is an independently operated music and sound-effects library for video
              creators, podcasters, livestreamers, businesses, game developers, and other digital
              creators who need usable audio for online projects.
            </p>
            <p>
              The library is built from audio that Viberary has the rights to host, distribute, and
              license. Viberary does not accept public audio uploads, and it does not redistribute
              recordings from outside artists, composers, producers, or third-party music libraries.
            </p>
            <p>
              Most Viberary music is instrumental. When a track includes vocal texture, it is used
              as a non-lyrical sound such as humming, chants, ooh sounds, or ahh sounds rather than
              sung lyrics.
            </p>
            <h2>How Creators Use Viberary</h2>
            <p>
              Visitors can preview tracks and sound effects, review the applicable license, and
              download the available audio files. Personal-use downloads do not require an account,
              full name, company name, or company email.
            </p>
            <p>
              Commercial-use requests ask for a full name, company name, and company email so
              Viberary can record and communicate the applicable commercial-use permission for the
              selected audio.
            </p>
            <p>
              Licensing, ownership, partnership, and support inquiries can be submitted through the
              Contact page.
            </p>
            <div class="trust-links">
              <router-link to="/music">Browse Music</router-link>
              <router-link to="/soundeffects">Sound Effects</router-link>
              <router-link to="/license-terms">License Terms</router-link>
              <router-link to="/privacy-policy">Privacy Policy</router-link>
              <router-link to="/contact-us">Contact</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SubFooter />
  </section>
</template>

<script>
import SubFooter from "../partials/SubFooter.vue";

export default {
  components: {
    SubFooter,
  }
}
</script>

<style scoped>
.trust-links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 22px;
}
.trust-links a {
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 999px;
  color: #222;
  padding: 8px 12px;
  text-decoration: none;
}
.trust-links a:hover {
  background: #ffd300;
  border-color: #ffd300;
}
</style>
